/* eslint-disable no-undef */
/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable func-names */
/* eslint-disable no-console */
import zenScroll from 'zenscroll';
import GA from './ga';

const Maps = {
	locations: [],
	bounds: null,
	map: null,
	infoWindow: null,
	GetInfoWindowContent(location) {
		return '<div class="info-window-content">'
			+ location.source.html()
			+ '</div>';
	},
	Populate() {
		Maps.bounds = new google.maps.LatLngBounds();
	
		$.each(Maps.locations, (index, value) => {
			value.marker.setMap(null);
		});
	
		Maps.locations = [];
	
		$('div[data-lat]').each((index, element) => {
			Maps.locations.push({
				id: $(element).attr('id'),
				title: $(element).find('.card-title').text(),
				source: $(element),
				lat: $(element).data('lat'),
				lng: $(element).data('lng'),
				zIndex: 9
			});
		});
	
		// Add each location to the map
		$.each(Maps.locations, (index, value) => {
			const location = value;
	
			const marker = new google.maps.Marker({
				position: new google.maps.LatLng(location.lat, location.lng),
				optimized: false,
				map: Maps.map
			});
	
			marker.setZIndex(location.zIndex);
	
			location.marker = marker;
			location.source.find('.show-on-map').on('click', () => {
				$('.card-location').removeClass('active');
				location.source.addClass('active');
				Maps.infoWindow.setContent(Maps.GetInfoWindowContent(location));
				Maps.infoWindow.open(Maps.map, marker);
				GA.TrackEvent("Maps", "Location Click", location.title);
			});
	
			Maps.bounds.extend(marker.position);
	
			// When the marker is clicked:
			marker.addListener('click', () => {
				// Show the info window
				Maps.infoWindow.setContent(Maps.GetInfoWindowContent(location));
				Maps.infoWindow.open(Maps.map, marker);
	
				GA.TrackEvent("Maps", "Marker Click", location.title);
	
				$('.card-location').removeClass('active');
				location.source.addClass('active');
	
				// Switch to the right tab:
				$('#' + location.source.parent('.location-county').attr('aria-labelledby')).click();
	
				setTimeout(() => {
					// Scroll the item into view
					const scroller = zenScroll.createScroller(location.source.parents('.locations')[0]);
					scroller.center(location.source[0]);
				}, 250);
			});
	
			Maps.map.fitBounds(Maps.bounds);
			if (Maps.map.getZoom() > 8) {
				Maps.map.setZoom(8);
			}
		});
	},
	Init() {
		Maps.map = new google.maps.Map(document.getElementById('map'), {
			center: { lat: 39.7581479, lng: -75.5718795 },
			zoom: 8,
			scrollwheel: false
		});
	
		// One InfoWindow to rule them all <-- only one will display at a time
		Maps.infoWindow = new google.maps.InfoWindow({ maxWidth: 400 });
	
		google.maps.event.addListener(Maps.infoWindow, 'closeclick', () => {
			GA.TrackEvent("Maps", "Close InfoWindow");
		});
	
		Maps.Populate();
	}
};

export default Maps;
window.MapInit = Maps.Init;